import { FC } from "react";
import styled from "styled-components";

import { Color, LoadingGroup, LoadingSkeleton } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Semibold, TextColor } from "capitalrx-components-2.0/lib/typography";

interface FindBestPriceDetailSectionProps {
  readonly title: string;
  readonly content: JSX.Element | string | JSX.Element[];
  readonly showLoading?: boolean;
}

export const NearbyPharmacyDetailSection = styled(Shelf)`
  border-bottom: solid 1px #313E48;
  padding-bottom: 8px;
`;

export const FindBestPriceDetailSection: FC<FindBestPriceDetailSectionProps> = ({ title, content, showLoading = true }) => {
  let fallback = <></>;

  if (showLoading) {
    fallback = <LoadingSkeleton style={{ height: 48, width: 240 }} />;
  }

  return (
    <LoadingGroup.Placeholder fallback={fallback}>
      <Stack spacing="mini">
        <Semibold>
          <TextColor appearance={Color.DarkGrey[400]}>
            {title}
          </TextColor>
        </Semibold>
        <Body>{content}</Body>
      </Stack>
    </LoadingGroup.Placeholder>
  );
};
